/* ============================================================
   KyDeco homepage — interactions
   Mobile drawer · JS-pinned sticky header · sticky mobile CTA
   Re-inits cleanly inside the Shopify theme editor.
   ============================================================ */
(function () {
  function initHeader(root) {
    if (!root || root.dataset.kdReady === '1') return;
    root.dataset.kdReady = '1';

    var header = root.querySelector('.header');
    var sentinel = root.querySelector('.kd-header-sentinel');
    var spacer = root.querySelector('.header-spacer');
    var mnav = root.querySelector('.mnav');
    var cta = root.querySelector('.sticky-cta');

    // Mobile drawer
    if (mnav) {
      var openBtn = root.querySelector('[data-kd-menu-open]');
      var open = function () { mnav.classList.add('open'); document.documentElement.style.overflow = 'hidden'; };
      var close = function () { mnav.classList.remove('open'); document.documentElement.style.overflow = ''; };
      if (openBtn) openBtn.addEventListener('click', open);
      mnav.querySelectorAll('[data-kd-close]').forEach(function (b) { b.addEventListener('click', close); });
      mnav.querySelectorAll('.mnav-links a').forEach(function (a) { a.addEventListener('click', close); });
    }

    // Scroll behaviour: pin header + shadow + sticky CTA
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset;
      if (header && sentinel && spacer) {
        var stuck = sentinel.getBoundingClientRect().top <= 0;
        header.classList.toggle('kd-fixed', stuck);
        spacer.classList.toggle('kd-on', stuck);
        spacer.style.height = stuck ? header.offsetHeight + 'px' : '0px';
      }
      if (header) header.classList.toggle('scrolled', y > 8);
      if (cta) cta.classList.toggle('show', y > 620);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-kd-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: a section can be re-rendered on its own
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-kd-header]');
    if (root) { root.dataset.kdReady = ''; initHeader(root); }
  });
})();
